const Router = (function() {
    let baseUrl = null;
    let currentRoute = null;

    /**
     * Constructor
     * @param urlBase
     * @constructor
     */
    function RouterConstructor (urlBase) {
        if (!urlBase) {
            throw new Error('Base url is not defined.');
        }

        baseUrl = urlBase;
        currentRoute = getCurrentRoute();
    }

    /**
     * Get segment by number
     * @param segment
     * @return {*|null}
     */
    RouterConstructor.prototype.getSegment = function (segment = null) {
        const segments = urlSegments(baseUrl);

        if (segment === null) {
            return segments;
        }

        return segments[segment]
            ? segments[segment]
            : null;
    };

    /**
     * Get segment by number
     * @return {*|null}
     * @param param
     */
    RouterConstructor.prototype.queryParam = function (param = null) {
        if(!param) {
            throw new Error('Params cannot be undefined.');
        }

        const params = urlQueryParameters();

        return params.hasOwnProperty(param)
            ? params[param]
            : null;
    };

    /**
     * Get current route name
     * @return {null}
     */
    RouterConstructor.prototype.getRouteName = function () {
        return currentRoute;
    };

    /**
     * Get current route name
     * @return {null}
     */
    RouterConstructor.prototype.isRouteActive = function (routeName) {
        return !routeName
            ? false
            : this.getRouteName() === routeName;
    };

    /**
     * Redirect to path
     * This method is working without changing history
     * @param path
     */
    RouterConstructor.prototype.redirect = function (path) {
        if (!path) {
            path = '/';
        }

        window.location.href = path;
    };

    /**
     * This method will reset url and will remove all query parameters and hastags
     * @param url
     */
    RouterConstructor.prototype.resetUrl = function (url) {
        return this.pushState(stripQueryStringAndHashFromPath(url));
    };

    /**
     * Will push an url through history
     * @param url
     * @param title
     */
    RouterConstructor.prototype.pushState = function (url, title = null) {
        return window.history.pushState({}, title, url);
    };

    /**
     * Get current route
     * @return {null|*}
     */
    function getCurrentRoute() {
        const currentRoute = document.head.querySelector('meta[name="current-route"]');

        if (!currentRoute.content) {
            return null;
        }

        return currentRoute.content;
    }

    /**
     * Remove base url from current url and split all segments
     * @param urlBase
     * @return {string[]}
     */
    function urlSegments(urlBase = null) {
        let url = window.location.href;

        if (!!urlBase) {
            url = url.replace(urlBase, '');
        }

        return url.split('/')
            .filter(item => !!item);
    }

    /**
     * Get all url query parameters
     * @return {{[p: string]: string}}
     */
    function urlQueryParameters() {
        const urlSearchParams = new URLSearchParams(window.location.search);
        return Object.fromEntries(urlSearchParams.entries());
    }

    /**
     * Remove all query or has tag parameters from url
     * @param url
     * @return {*}
     */
    function stripQueryStringAndHashFromPath(url) {
        return url.split("?")[0].split("#")[0];
    }

    return RouterConstructor;
})();

export default Router;